import { Link } from "react-router-dom";

export default function CancelPage() {
  return (
    <div className="min-h-screen bg-[#FFFDF9] flex items-center justify-center px-6 py-24">
      <div
        className="max-w-lg w-full text-center border border-[#E8D7D0] rounded-3xl p-10 bg-white"
        data-testid="cancel-page"
      >
        <span className="text-[11px] tracking-[0.3em] uppercase text-[#C48B9F]">
          No worries
        </span>
        <h1 className="mt-4 font-serif-me text-4xl sm:text-5xl text-[#36292A]">
          Your basket is right where you left it.
        </h1>
        <p className="mt-5 text-[#7D6B6D] leading-relaxed">
          The payment was cancelled and you haven't been charged. Take your
          time — the boxes are waiting.
        </p>
        <div className="mt-10 flex justify-center gap-3">
          <Link
            to="/#boxes"
            className="me-btn-primary"
            data-testid="cancel-back-boxes"
          >
            Back to the boxes
          </Link>
          <Link to="/" className="me-btn-ghost" data-testid="cancel-back-home">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
